import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'env/environment';
import { ConfirmModalComponent } from '../../modal/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-service-steps',
  standalone: true,
  imports: [TranslateModule, NgClass, ConfirmModalComponent],
  templateUrl: './service-steps.component.html',
  styleUrl: './service-steps.component.scss'
})
export class ServiceStepsComponent implements OnInit, OnChanges {
  @Input() steps!: string[];
  @Input() serviceName: string = 'visitRoom';
  @Input() activeItem?: string;
  @Input() lastAvailableStep!: string;
  @Input() disablePreviousSteps: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() frontofficeStatus: string = 'New';
  @Input() clientStatus: string = 'New';
  @Input() isSubmitted: boolean = false;
  @Output() stepSelected: EventEmitter<string> = new EventEmitter<string>();
  /**
   * Raised alongside stepSelected when the step change is the operator's answer to the
   * "izmaiņas netiks saglabātas" prompt, so the host can skip the save it would otherwise
   * run on the way out of the step being left (LNA-1850 R2).
   */
  @Output() changesDiscarded: EventEmitter<string> = new EventEmitter<string>();
  currentlySelected: string = '';
  pendingStep: string = '';
  isOpenConfirmBack: boolean = false;
  @Input() hasFormChanged: boolean = false;

  constructor(private router: Router) {}

  ngOnInit() {
    if (this.activeItem) {
      this.currentlySelected = this.activeItem;
    } else {
      this.currentlySelected = this.steps[0];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeItem'] && this.activeItem) {
      this.currentlySelected = this.activeItem;
    }
  }

  handleClick(item: string, confirmed: boolean = false) {
    const selectedIndex = this.steps.findIndex((step) => step === item) + 1;
    this.pendingStep = item;

    if (this.hasFormChanged && !confirmed) {
      this.isOpenConfirmBack = true;
    } else {
      this.stepSelected.emit(item);
      if (confirmed) {
        this.changesDiscarded.emit(item);
      }
      this.router.navigate([], {
        queryParams: { solis: selectedIndex },
        queryParamsHandling: 'merge'
      });
    }
  }

  get isMobile(): boolean {
    return environment.isMobile;
  }
}
